export enum PageWithCardVariant {
  Simple = 'simple',
  Headerless = 'headerless',
  FeaturedImage = 'featured-image',
}
